// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Client Balance — wallet icon inside nav-item + tooltip ── */

.client-balance-inline {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  color: var(--text-tertiary, #adb5bd);
  transition: background 0.15s, color 0.15s;
  cursor: pointer;
}

.client-balance-inline:hover {
  background: rgba(0, 0, 0, 0.06);
  color: var(--text-secondary, #868e96);
}

.client-balance-inline.is-active {
  background: rgba(255, 107, 74, 0.10);
  color: var(--accent-orange, #FF6B4A);
}

/* Tooltip */
.client-balance-tooltip {
  position: absolute;
  top: 100%;
  left: 16px;
  right: 16px;
  margin-top: 4px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  padding: 10px 14px;
  box-shadow:
    0 4px 12px rgba(0, 0, 0, 0.08),
    0 8px 28px rgba(0, 0, 0, 0.06);
  z-index: 300;
  animation: balanceTipIn 0.12s ease-out;
}

@keyframes balanceTipIn {
  from { opacity: 0; transform: translateY(-3px); }
  to { opacity: 1; transform: translateY(0); }
}

.client-balance-tooltip-label {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: var(--text-tertiary, #adb5bd);
  margin-bottom: 2px;
}

.client-balance-tooltip-amount {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary, #1a1a1a);
  letter-spacing: -0.3px;
}

.client-balance-tooltip-amount.positive {
  color: #27ae60;
}

.client-balance-tooltip-amount.negative {
  color: #e53935;
}

.client-balance-tooltip-symbol {
  font-size: 13px;
  font-weight: 500;
  opacity: 0.5;
  margin-right: 2px;
}

.client-balance-tooltip-cents {
  font-size: 13px;
  font-weight: 500;
  opacity: 0.45;
}
`, "",{"version":3,"sources":["webpack://./src/styles/client-balance.css"],"names":[],"mappings":"AAAA,iEAAiE;;AAEjE;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB;;kCAEgC;EAChC,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf","sourcesContent":["/* ── Client Balance — wallet icon inside nav-item + tooltip ── */\n\n.client-balance-inline {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 6px;\n  color: var(--text-tertiary, #adb5bd);\n  transition: background 0.15s, color 0.15s;\n  cursor: pointer;\n}\n\n.client-balance-inline:hover {\n  background: rgba(0, 0, 0, 0.06);\n  color: var(--text-secondary, #868e96);\n}\n\n.client-balance-inline.is-active {\n  background: rgba(255, 107, 74, 0.10);\n  color: var(--accent-orange, #FF6B4A);\n}\n\n/* Tooltip */\n.client-balance-tooltip {\n  position: absolute;\n  top: 100%;\n  left: 16px;\n  right: 16px;\n  margin-top: 4px;\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  border-radius: 10px;\n  padding: 10px 14px;\n  box-shadow:\n    0 4px 12px rgba(0, 0, 0, 0.08),\n    0 8px 28px rgba(0, 0, 0, 0.06);\n  z-index: 300;\n  animation: balanceTipIn 0.12s ease-out;\n}\n\n@keyframes balanceTipIn {\n  from { opacity: 0; transform: translateY(-3px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.client-balance-tooltip-label {\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  color: var(--text-tertiary, #adb5bd);\n  margin-bottom: 2px;\n}\n\n.client-balance-tooltip-amount {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--text-primary, #1a1a1a);\n  letter-spacing: -0.3px;\n}\n\n.client-balance-tooltip-amount.positive {\n  color: #27ae60;\n}\n\n.client-balance-tooltip-amount.negative {\n  color: #e53935;\n}\n\n.client-balance-tooltip-symbol {\n  font-size: 13px;\n  font-weight: 500;\n  opacity: 0.5;\n  margin-right: 2px;\n}\n\n.client-balance-tooltip-cents {\n  font-size: 13px;\n  font-weight: 500;\n  opacity: 0.45;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
